/**
 * SiteHeader component - Header inside SidebarInset
 * Based on shadcn/ui dashboard-01 block design
 */

import { Separator } from '@/components/ui/separator'
import {
  SidebarTrigger,
} from '@/components/ui/sidebar'
import { BreadcrumbNavigation } from './BreadcrumbNavigation'
import { UserMenu } from './UserMenu'

export function SiteHeader() {
  return (
    <header className="flex h-16 shrink-0 items-center gap-2 border-b px-2 sm:px-4">
      <div className="flex items-center gap-1 sm:gap-2 flex-1 min-w-0">
        <SidebarTrigger className="-ml-1" />
        <Separator orientation="vertical" className="mr-1 sm:mr-2 h-4 hidden sm:block" />
        <div className="flex-1 min-w-0 overflow-hidden">
          <BreadcrumbNavigation />
        </div>
        <div className="ml-auto shrink-0">
          <UserMenu />
        </div>
      </div>
    </header>
  )
}

